import React from 'react';
import PropTypes from 'prop-types';
import { PRODUCTION_ADDED_IDENTIFIERS_IDS } from '../../constants/consts';
import MaskIcon from '../Icons/MaskIcon';
import { isRedMask } from '../../utils/common';
const { UNKNOWN } = PRODUCTION_ADDED_IDENTIFIERS_IDS;

const ProductionMaskIcon = ({ addedBy, className }) => {
  const addedById = addedBy?.id;
  const isUnknown = addedById === UNKNOWN;

  return !isUnknown && <MaskIcon isRed={isRedMask(addedById)} className={className} />;
};

ProductionMaskIcon.propTypes = {
  addedBy: PropTypes.shape({
    slug: PropTypes.string,
    id: PropTypes.number,
  }),
  className: PropTypes.string,
};

export default ProductionMaskIcon;
